// every login page hardcodes its own colours instead of reading the theme, so anything
// themed drawn over one has to be told which side the page is on
const LIGHT_LOGIN_BRANDS = [
  "antos",
  "antospnc",
  "apinternational", // TODO(AP-153): follows its borrowed Antos login page
  "blueocean",
  "fundamarkets",
  "pxmarkets",
  "worthycodes",
];

const loginPageTheme = (brand) =>
  LIGHT_LOGIN_BRANDS.includes(brand) ? "light" : "dark";

export default loginPageTheme;
